import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { KEY_WORDS_KEY } from '@/data/forReactAndMobile/constants';
import { ProductType } from '@/data/types/Product';
import { useMobileApp } from '@/utils/useMobileApp';

import { useTrackException } from 'presentation/events/hooks/useTrackException';
import { updateSelectedPromotionListPartnumbers } from 'presentation/events/hooks/useTrackSelectPromotion/utils';

type UseSyncPromotionListPartnumbersProps = {
	products?: ProductType[];
};

export const useSyncPromotionListPartnumbers = ({
	products,
}: UseSyncPromotionListPartnumbersProps) => {
	const pathname = usePathname();
	const trackException = useTrackException();
	const { isMobileApp } = useMobileApp();
	const [, , removeCookie] = useCookies([KEY_WORDS_KEY]);

	useEffect(() => {
		if (!pathname) return;
		if (!products || products.length === 0) return;

		const isPlpRoute = pathname.includes('/s/') || pathname.includes('/b/');
		if (!isPlpRoute) return;

		try {
			const partnumbers = products
				.map((product) => product.partNumber)
				.filter((partnumber): partnumber is string => Boolean(partnumber));

			if (partnumbers.length === 0) return;

			const updated = updateSelectedPromotionListPartnumbers(partnumbers, pathname);

			if (updated && isMobileApp) {
				removeCookie(KEY_WORDS_KEY, { path: '/' });
			}
		} catch (error) {
			console.error('Error syncing promotion list_partnumbers', error);
			trackException(error);
		}
	}, [pathname, products, trackException, isMobileApp, removeCookie]);
};
